import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';

Vue.use(Vuex);

const baseUrl = process.env.VUE_APP_LOCAL_ONLY === "true" ? "https://coinsnap.os24.work/api/internal" : '/api/internal';
const domain = process.env.VUE_APP_LOCAL_ONLY === "true" ? "https://coinsnap.os24.work" : 'https://coinsnap.io';
const aat = process.env.VUE_APP_LOCAL_ONLY === "true" ? process.env.VUE_APP_ADMIN_TOKEN : ''
const creds = process.env.VUE_APP_LOCAL_ONLY === "true" ? 'omit' : 'include'

function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1);
    }
  }
}

async function getApiCall(hook, json = true) {
  if (!hook) throw new Error("Hook is required");

  const res = await fetch(`${baseUrl}${hook}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "admin-access-token": aat,
      "cn-token": getCookie('cn-token'),
      credentials: creds,
    },
  });

  return json ? res.json() : res;
}

async function getApiReport(hook, range, type) {
  const res = await fetch(`${baseUrl}${hook}`, {
    method: "GET",
    headers: {
      Accept: "text/csv;charset=utf-8",
      "Content-Type": "application/json", "admin-access-token": aat, "cn-token": getCookie('cn-token'),
      credentials: creds,
    }
  });
  return res;
}

async function postApiCall(hook, payload = {}, json, url, xApiKey) {
  try {
    if (!url) url = baseUrl;
    let res = await fetch(`${url}${hook}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "admin-access-token": aat, "cn-token": getCookie('cn-token'), "x-api-key": xApiKey },
      credentials: creds,
      body: JSON.stringify(payload),
    });
    if (res.status ==- 404) {
      return null;
    }
    res = json ? await res.json() : res;
    return res;
  } catch (e) {
    console.log(e);
  }
}

async function putApiCall(hook, payload = {}) {
  const res = await fetch(`${baseUrl}${hook}`, {
    method: "PUT",
    headers: {"Content-Type": "application/json", "admin-access-token": aat, "cn-token": getCookie('cn-token'),},
    credentials: creds,
    body: JSON.stringify(payload),
  });
  if (res.status === 404) {
    return null;
  }
  return res;
}

// async function getApiCall(hook) {
//   if (!hook) hook = payload?.hook
//   const res = await fetch(`${baseUrl}${hook}`, {
//     method: "GET",
//     credentials: "include",
//   });
//   const resJSON = await res.json();
//   return resJSON;
// }

// async function postApiCall(hook, payload = {}, json, url, xApiKey) {
//   if(!url) url = baseUrl
//   let res = await fetch(`${url}${hook}`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json", "x-api-key": xApiKey },
//     credentials: "include",
//     body: JSON.stringify(payload)
//   });
//   if (res.status == 404) {
//     return null;
//   }
//   res = json ? await res.json() : res;
//   return res;
// }
// async function putApiCall(hook, payload = {}) {
//   const res = await fetch(`${baseUrl}${hook}`, {
//     method: "PUT",
//     headers: { "Content-Type": "application/json" },
//     credentials: "include",
//     body: JSON.stringify(payload),
//   });
//   if (res.status == 404) {
//     return null;
//   }
//   return res;
// }

let getConfig = {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
    "admin-access-token": aat,
    "cn-token": getCookie('cn-token')
  },
  credentials: creds
};

export default new Vuex.Store({
  state: {
    baseUrl: domain,
    connectedStore: false,
    apiData: null,
    alertsData: null,
  },
  mutations: {
    // updateXPubValue(state, payload) {
    //   state.xPubValue = payload;
    // },
    SET_ALERTS_DATA(state, data) {
      // Replace the entire object to ensure reactivity
      state.alertsData = { ...data };
    },

    SET_API_DATA(state, data) {
      // Replace the entire object to ensure reactivity
      state.apiData = { ...data };
    },

    // Mutation in your Vuex store
    SET_MULTIPLE_API_DATA(state, updates) {
      // Use spread operator to create a new object with updated values
      state.apiData = {
        ...state.apiData,
        ...updates
      };
    }
  },
  actions: {
    async getApiCallAction(context, payload) {
      return await getApiCall(payload.hook, payload.json);
    },
    async getApiReport(context, payload) {
      return await getApiReport(payload.hook, payload.range, payload.type)
    },
    async postApiCallAction(context, payload) {
      return await postApiCall(payload.hook, payload.body, payload.json, payload.url, payload.xApiKey);
    },
    async putApiCallAction(context, payload) {
      return await putApiCall(payload.hook, payload.body);
    },
    getLogout() {
      // Clear cookie across the entire domain and paths
      document.cookie = "cn-token=; path=/; domain=localhost; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

      // Clear Vuex state or session
      if (this.$store) {
        this.$store.commit("CLEAR_USER_SESSION"); // Ensure you have this mutation
      }

      // Redirect to the login page instead of reloading
      window.location.href = "/login";
    },
    async deleteWebhook(context, payload) {
      const res = await fetch(`${baseUrl}/stores/webhooks/${payload}`, {
        method: "DELETE",
        headers: {"Content-Type": "application/json", "admin-access-token": aat, "cn-token": getCookie('cn-token'),},
        credentials: creds,
      });
      if (res.status === 404) {
        return null;
      }
      return res;
    },
    async deleteButton(context, payload) {
      const res = await fetch(`${baseUrl}/payment-buttons/${payload}`, {
        method: "DELETE",
        headers: {"Content-Type": "application/json", "admin-access-token": aat, "cn-token": getCookie('cn-token'),},
        credentials: creds,
      });
      if (res.status === 404) {
        return null;
      }
      return res;
    },
    async deleteAlert(context, payload) {
      const res = await fetch(`${baseUrl}/alerts/system/${payload}`, {
        method: "DELETE",
        headers: {"Content-Type": "application/json", "admin-access-token": aat, "cn-token": getCookie('cn-token'),},
        credentials: creds,
      });
      if (res.status === 404) {
        return null;
      }
      return res;
    },
    async deletePOS(context, payload) {
      const res = await fetch(`${baseUrl}/pos/${payload}`, {
        method: "DELETE",
        headers: {"Content-Type": "application/json", "admin-access-token": aat, "cn-token": getCookie('cn-token'),},
        credentials: creds,
      });
      if (res.status === 404) {
        return null;
      }
      return res;
    },
    async deleteShopifySettings(context, payload) {
      const res = await fetch(`${baseUrl}/shopify/settings/${payload}`, {
        method: "DELETE",
        headers: {"Content-Type": "application/json", "admin-access-token": aat, "cn-token": getCookie('cn-token'),},
        credentials: creds,
      });
      if (res.status === 404) {
        return null;
      }
      return res;
    },
    async getPdfExport(context, payload) {
      const res = await fetch(`${baseUrl}/monthly-statements/${payload}/export-pdf`, {
        method: "GET",
        headers: {"Accept": "application/pdf", "admin-access-token": aat, "cn-token": getCookie('cn-token'),},
        credentials: creds,
      });
      if (res.status === 404) {
        return null;
      }

      const blob = await res.blob();
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `coinsnap-${payload}.pdf`
      link.click()

      return res;

    },

    // async putDFXCompany(context, payload) {
    //   const res = await putApiCall('/companies/modify', context, payload)
    //   return res;
    // },

    // async putDFXUser(context, payload) {
    //   const res = await putApiCall('/users/modify/modify', context, payload)
    //   return res
    // },

    async fetchApiData({ commit }) {
      try {
        const config = {
          ...getConfig,
          url: `${baseUrl}/settings`,
          headers: {
            "Content-Type": "application/json",
            "admin-access-token": aat,
            "cn-token": getCookie('cn-token'),
            credentials: creds,
          }
        };

        const response = await axios(config);
        commit('SET_API_DATA', response.data);
        return response.data; // Return the data
      } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
      }
    },

    async fetchAlertsData({ commit }) {
      try {
        const config = {
          ...getConfig,
          url: `${baseUrl}/alerts`,
          headers: {
            "Content-Type": "application/json",
            "admin-access-token": aat,
            "cn-token": getCookie('cn-token'),
            credentials: creds,
          }
        };

        const response = await axios(config);
        commit('SET_ALERTS_DATA', response.data);
        return response.data; // Return the data
      } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
      }
    }
  },
  getters: {
    getBaseUrl(state) {
      return state.baseUrl;
    },
    getCheckDashboard(state) {
      return state.connectedStore;
    },
    getApiData: state => state.apiData,
    getAlertsData: state => state.alertsData
  },
});
